import { FormControlBase } from './form-control-base';

export class DropdownControl extends FormControlBase<string> {
    public controlType: string = 'dropdown';
    public options = new Array<{ key: string, value: string }>(); 
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/dynamic-form/dropdown-control.ts